export default __webpack_public_path__ + "static/media/employees_3.21f5fe07.png";